export function getCachedAuthToken() {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key && key.startsWith('@@auth0spajs@@')) {
            const value = localStorage.getItem(key)
            try {
                const parsed = JSON.parse(value!)
                return parsed.body?.access_token || null
            } catch {
                return null
            }
        }
    }
    return null
}
